<nav class="toolbar navbar navbar-light toolbar-no-button"></nav> <!--emarti69: nav vacío debido a que el scroll está hecho en base a la altura del container y del footer. La existencia del nav influye en la altura del scroll, por tanto se necesita que haya uno, aunque no tenga botón, del tamaño de los que tienen botón.-->
<div id="homebox" class="container-fluid container-list">
    <div class="home-margin-box">
        <div>
            <span>
                <img src="assets/images/Titulo_Instrucciones.png" />
            </span>
        </div>
        <br />
        <br />
        <b><u><span>{{title}}</span></u></b>
        <br />
        <br />
        <b><span>{{subtitle}}</span></b>
        <br />
        <br />
        <div>
            {{p1}}
            <br />
            <br />
            <ul>
                <li>
                    {{p1l1}}
                    <ul>
                        <li>
                            {{p1l1l1}}
                        </li>
                        <li>
                            {{p1l1l2}}
                        </li>
                    </ul>
                </li>
                <li>
                    {{p1l2}}
                    <ul>
                        <li>
                            {{p1l2l1}}
                        </li>
                    </ul>
                </li>
                <li>
                    {{p1l3}}
                    <ul>
                        <li>
                            {{p1l3l1}}
                        </li>
                        <li>
                            {{p1l3l2}}
                        </li>
                        <li>
                            {{p1l3l3}}
                        </li>
                    </ul>
                </li>
            </ul>
        </div>

        <div>
            {{p2}} <a href="https://sede.mapa.gob.es/portal/site/seMAPA/ficha-procedimiento?procedure_suborg_responsable=91&procedure_id=278">solicitud en papel.</a>
        </div>
        <br />
        <div>
            {{p3}} <a href="https://sede.mapa.gob.es/portal/site/seMAPA/ficha-procedimiento?procedure_suborg_responsable=91&procedure_id=278">Solicitud de inscripción</a> {{p3cont}}
            <ol>
                <li>
                    {{p3l1}} <a href="https://sede.mapa.gob.es/portal/site/seMAPA/ficha-procedimiento?procedure_suborg_responsable=91&procedure_id=278">Sede Electrónica</a> {{p3l1cont}}
                </li>
                <li>
                    {{p3l2}}
                    <ul>
                        <li>
                            {{p3l2l1}}
                        </li>
                        <li>
                            {{p3l2l2}}
                        </li>
                    </ul>
                </li>
            </ol>
        </div>
        <br />
        <div>
            {{p4}}
            <ul>
                <li>
                    {{p4l1}}
                </li>
                <li>
                    {{p4l2}}
                </li>
            </ul>
        </div>
        <div>
            {{p5}}
        </div>
    </div>
</div>
